<template>
  <div>
    <el-dialog
      :visible.sync="dialogVisible"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      :before-close="beforeClose"
      title="地点管理"
      :modal-append-to-body="false"
      width="35%"
      style="margin-top: 100px"
    >
      <div class="container_dialog">
        <div class="container_item">
          <div class="label">地点名称</div>
          <div class="value">
            <el-input v-model="form.place" placeholder="请输入"></el-input>
          </div>
        </div>
        <div class="container_item">
          <div class="label">地点地址</div>
          <div class="value">
            <el-input v-model="form.address" placeholder="请输入"></el-input>
          </div>
        </div>
        <div class="container_item">
          <div class="label">总库存数量</div>
          <div class="value">
            <el-input
              type="number"
              v-model="form.stock"
              placeholder="请输入"
              :disabled="itemList.id ? true : false"
            ></el-input>
          </div>
        </div>
        <div class="container_item">
          <div class="label">管理员</div>
          <div class="value">
            <el-select
              v-model="form.adminNo"
              placeholder="请输入管理员名字"
              clearable
              filterable
              remote
              :remote-method="changeOption"
              :loading="loadingSelect"
              ref="select"
              @blur.native.capture="onblur"
              @hook:mounted="cancalReadOnly"
              @visible-change="cancalReadOnly"
              @change="handleChange"
            >
              <el-option
                v-for="item in optionPeople"
                :key="item.workcode"
                :label="item.orgname + '-' + item.name"
                :value="item.workcode"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="container_item">
          <div class="label">权重</div>
          <div class="value">
            <el-input
              type="number"
              v-model="form.sort"
              placeholder="请输入"
            ></el-input>
          </div>
        </div>
        <div class="container_item">
          <div class="label">是否启用</div>
          <div class="value">
            <el-switch
              style="display: block; margin-top: 15px"
              v-model="form.state"
              active-color="#4FA27D"
            >
            </el-switch>
          </div>
        </div>
        <!-- <div class="container_item" style="width: 100%">
          <div class="label">上传图片</div>
          <div class="value fild_value_upload">
            <el-upload
              :action="`${upload}/file/upload`"
              list-type="picture-card"
              :file-list="beforeImageList"
              :on-success="handleBeforeImage"
              accept=".jpg,.jpeg,.png"
              class="upload"
              :limit="1"
            >
              <i slot="default" class="el-icon-plus"></i>
              <div slot="file" slot-scope="{ file }">
                <img
                  class="el-upload-list__item-thumbnail"
                  :src="file.url"
                  alt=""
                />
                <span class="el-upload-list__item-actions">
                  <span
                    class="el-upload-list__item-preview"
                    @click="previewBeforeImage(file)"
                  >
                    <i class="el-icon-zoom-in"></i>
                  </span> -->
                  <!-- <span
                class="el-upload-list__item-delete"
                @click="handleRemove(file)"
              >
                <i class="el-icon-delete"></i>
              </span> -->
                <!-- </span>
              </div>
            </el-upload>
          </div>
        </div> -->
      </div>
      <span slot="footer" class="dialog-footer">
        <template>
          <el-button @click="finished" class="no">取消</el-button>
          <el-button @click="submit" class="ok"> 提交 </el-button>
        </template>
      </span>
    </el-dialog>
    <el-dialog :visible.sync="dialogVisibleImg" class="dialogImg">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </div>
</template>

<script>
// import moment from "moment";
import api from "@/apis/medal";
import apis from "@/apis/borrowingAnUmbrella";
import { getToken } from "@/utils/cookie";
export default {
  name: "dialog",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: "1",
    },
    itemList: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      dialogVisible: false,
      time: "",
      state: true,
      form: {
        place: "",
        address: "",
        stock: "",
        adminNo: "",
        adminName: "",
        sort: "",
        image: [],
        state: true,
      },
      beforeImageList: [
        // {
        //   url:api.imgUrl + "10086",
        // }
      ],
      upload: "",
      dialogVisibleImg: false,
      dialogImageUrl: "",
      loadingSelect: false,
      optionPeople: [],
    };
  },
  watch: {
    visible(v) {
      this.dialogVisible = v;
      if (v) {
        if (this.itemList.id) {
          console.log(this.itemList,'this.itemList');
          
          this.form = {
            ...this.itemList,
            state: this.itemList.state == 1 ? true : false,
            adminNo: this.itemList.adminName,
            image: this.itemList.image.split(","),
          };
          this.beforeImageList = this.form.image.map((item) => ({
            url: api.imgUrl + item,
          }));
        } else {
          this.form = {
            place: "",
            address: "",
            stock: "",
            adminNo: "",
            adminName: "",
            sort: "",
            image: [],
            state: true,
          };
          this.beforeImageList = [];
        }
        this.optionPeople = []
      }
    },
  },
  mounted() {
    this.upload = api.upload;
  },
  methods: {
    //获取管理员名字
    changeOption(value) {
      this.loadingSelect = true;
      api
        .quaGetEmployeeInfo({
          name: value,
        })
        .then((data) => {
          this.optionPeople = data.data;
          this.loadingSelect = false;
        });
    },
    //选择管理员名字
    handleChange() {
      this.form.adminName = this.optionPeople.find(
        (item) => item.workcode == this.form.adminNo
      ).name;
    },
    //在苹果手机上唤起键盘
    onblur() {
      setTimeout(() => {
        if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
          //判断iPhone|iPad|iPod|iOS
          this.$refs.select.blur();
        }
        var scrollHeight =
          document.documentElement.scrollTop || document.body.scrollTop || 0;
        window.scrollTo(0, Math.max(scrollHeight - 1, 0));
      }, 100);
    },
    // 在苹果手机上唤起键盘 取消只读
    cancalReadOnly(onOff) {
      this.$nextTick(() => {
        if (!onOff) {
          const { select } = this.$refs;
          const input = select.$el.querySelector(".el-input__inner");
          input.removeAttribute("readonly");
        }
      });
    },
    // 图片放大预览
    previewBeforeImage(file) {
      this.dialogImageUrl = file.response
        ? api.imgUrl + file.response.id
        : file.url;
      this.dialogVisibleImg = true;
    },
    //上传图片
    handleBeforeImage(file) {
      console.log(file, "file");

      this.form.image.push(file.id);
    },
    //关闭弹窗
    beforeClose(done) {
      this.step = 1;
      this.fileList = [];
      this.$emit("update:visible", false);
      done();
    },
    //刷新数据
    finished() {
      this.step = 1;
      this.fileList = [];
      this.$emit("update:visible", false);
      this.$emit("changeUpload");
    },
    // 提交数据
    submit() {
      if(!this.form.place) return this.$message.error("请输入地点名称");
      if(!this.form.address) return this.$message.error("请输入地点地址");
      if(!this.form.stock) return this.$message.error("请输入库存数量");
      if(!this.form.adminNo) return this.$message.error("请输入管理员名称");
      if(!this.form.sort) return this.$message.error("请输入权重");
      // if(this.form.image.length == 0) return this.$message.error("请上传图片");

      const params = {
        place: this.form.place,
        address: this.form.address,
        stock: this.form.stock,
        adminNo: this.form.adminNo,
        adminName: this.form.adminName,
        sort: this.form.sort,
        // image: this.form.image.join(","),
        image:'',
        state: this.form.state ? 1 : 2,
        empNo: getToken(),
      };
      if (this.itemList.id) {
        params.id = this.itemList.id;
        console.log(this.itemList.adminNo, "this.itemList.adminNo");
        console.log(this.form.adminNo, "this.form.adminNo");
        
        params.adminNo =
          this.optionPeople.length > 0
            ? this.form.adminNo
            : this.itemList.adminNo;
      }
      apis.placeCreate(params).then((res) => {
        console.log(res, "res");
        this.$emit("changeSubmit");
        this.$emit("update:visible", false);
        this.$message({
          type: "success", // success error warning
          message: "请前往库存管理维护！",
          duration: 2000,
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;
.container_dialog {
  padding-left: 50px;
  display: flex;
  flex-wrap: wrap;
  .container_item {
    // display: flex;
    // align-items: center;
    font-size: 11px * $zoom;
    margin-bottom: 50px;
    width: 50%;
    color: #282b32;
    .value {
      // margin-left: 20px;
      flex: 1;
      display: flex;
      align-items: center;
      ::v-deep {
        .el-input,
        .el-date-editor {
          width: 90%;
          height: 30px * $zoom;
          background: #fafafa;
          border-radius: 20px;
          margin-top: 20px;
          .el-input__inner {
            width: 100%;
            height: 30px * $zoom !important;
            background: #fafafa;
            // border: 1px solid #ccc;
            border-radius: 20px;
          }
          .el-range-separator {
            line-height: 33px * $zoom !important;
            padding: 0 40px 0 20px;
          }
        }
        .el-select {
          width: 100%;
        }
        .el-switch__core {
          width: 88px !important;
          height: 48px !important;
          border-radius: 50px;
        }
        .el-switch__label {
          color: #282b32;
        }
        .el-switch__label * {
          font-size: 32px !important;
        }
        .el-switch__core:after {
          width: 40px;
          height: 40px;
        }
        .el-switch.is-checked .el-switch__core::after {
          margin-left: -43px;
        }
      }
    }
    .fild_value_upload {
      .upload {
        display: flex;
        flex-wrap: wrap;
        margin-top: 30px;
      }
      ::v-deep {
        .el-upload {
          width: 180px !important;
          height: 180px !important;
          line-height: 190px !important;
          background: #fafafa;
          border: 1px solid #c0ccda;
        }
        .el-upload--picture-card i {
          color: #4fa27d;
        }
        .el-upload-list__item {
          width: 180px !important;
          height: 180px !important;
          img {
            width: 100%;
            height: 100%;
          }
        }
      }
    }
  }
  .container_item:nth-child(1) {
    .value {
      color: #666666;
    }
  }
}
.dialog-footer {
  .ok {
    width: 75px * $zoom;
    height: 32px * $zoom;
    background: #4fa27d;
    border-radius: 20px;
    font-size: 11px * $zoom;
    color: #fff;
    span {
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  .no {
    width: 75px * $zoom;
    height: 32px * $zoom;
    background: none;
    border-radius: 20px;
    font-size: 11px * $zoom;
    color: #666;
    border: 1px solid #666;
    span {
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}
.dialogImg {
  .el-dialog {
    margin-top: 0 !important;
    width: 100% !important;
    margin: 0 !important;
    .el-dialog__body {
      height: calc(100vh - 55px);
      overflow: auto;
    }
  }
}
::v-deep {
  .el-dialog {
    margin-top: 0 !important;
    border-radius: 30px;
  }
  .el-dialog__header {
    padding: 0 !important;
    height: 150px;
    border-bottom: 1px solid #ccc;
    position: relative;
    .el-dialog__title {
      position: absolute;
      top: 35%;
      left: 50px;
    }
    .el-dialog__headerbtn {
      top: 35%;
      font-size: 40px;
    }
  }
  .el-dialog__body {
    // background: #f7f9fa;
    // height: 75vh;
    // overflow: auto;
    // &::-webkit-scrollbar {
    // display: none;
    // }
  }
}
</style>
